(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ReplayViewer", [], factory);
	else if(typeof exports === 'object')
		exports["ReplayViewer"] = factory();
	else
		root["ReplayViewer"] = factory();
})(self, function() {
return 